// Controls
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle } from "@fluentui/react-components";
import { Dismiss } from "@ms/planner-generic-controls/lib/local/icons";
import { DueDateLateFilled } from "@ms/planner-generic-controls/lib/local/icons";
// Resources
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
// Styles
import { useSensitivityLabelWarningDialogStyles } from "./SensitivityLabelWarningDialog.styles";
// Utilities
import * as StringHelper from "@fluentui/utilities";
import * as React from "react";
/**
 * Warning dialog shown when a user attempts to attach a file whose sensitivity label
 * is higher than the plan's sensitivity label.
 */ export const SensitivityLabelWarningDialog = ({ planSensitivityLabelName, fileSensitivityLabelName, onAddFileAnyway, onDismiss })=>{
    const styles = useSensitivityLabelWarningDialogStyles();
    const handleAddFileAnyway = ()=>{
        onAddFileAnyway();
        onDismiss();
    };
    const handleOpenChange = (_, data)=>{
        if (data.open === false) {
            onDismiss();
        }
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: true,
        onOpenChange: handleOpenChange
    }, /*#__PURE__*/ React.createElement(DialogSurface, {
        className: styles.root,
        "aria-label": Strings.GroundingResourcesDialog_SensitivityWarningDialogTitle,
        "data-testid": "sensitivity-label-warning-dialog"
    }, /*#__PURE__*/ React.createElement(DialogBody, null, /*#__PURE__*/ React.createElement(DialogTitle, {
        className: styles.title,
        action: /*#__PURE__*/ React.createElement(Button, {
            appearance: "transparent",
            icon: /*#__PURE__*/ React.createElement(Dismiss, null),
            onClick: onDismiss,
            "aria-label": Strings.SharedComponents_CloseButtonText,
            "data-testid": "sensitivity-label-warning-dismiss-button"
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.titleContent
    }, /*#__PURE__*/ React.createElement("span", {
        className: styles.warningIcon
    }, /*#__PURE__*/ React.createElement(DueDateLateFilled, null)), /*#__PURE__*/ React.createElement("span", null, Strings.GroundingResourcesDialog_SensitivityWarningDialogTitle))), /*#__PURE__*/ React.createElement(DialogContent, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.message
    }, StringHelper.format(Strings.GroundingResourcesDialog_SensitivityWarningDialogBody, planSensitivityLabelName, fileSensitivityLabelName)))), /*#__PURE__*/ React.createElement(DialogActions, {
        className: styles.dialogActions
    }, /*#__PURE__*/ React.createElement(Button, {
        appearance: "secondary",
        className: styles.actionButton,
        onClick: onDismiss,
        "data-testid": "sensitivity-label-warning-cancel-button"
    }, Strings.SharedComponents_CancelButtonText), /*#__PURE__*/ React.createElement(Button, {
        appearance: "primary",
        className: styles.actionButton,
        onClick: handleAddFileAnyway,
        "data-testid": "confirm-add-file-anyway-button"
    }, Strings.GroundingResourcesDialog_SensitivityWarningAddFileAnyway))));
};
